import React from 'react';
import ObjectiveForm from '@components/objectives/ObjectiveForm';
import { useGetCurrentUserQuery } from '@teachur/http-client';

const CreateObjective = () => {
  const { data: user } = useGetCurrentUserQuery();

  if (!user) {
    return null;
  }

  return <ObjectiveForm objective={{ id: -1 }} />;
};

export default CreateObjective;
